import { DepartmentDto, OperationAvailabilityDto } from "../../autogen/bff-api";

const CREATE_SOURCING_EVENT = "CreateSourcingEvent";

const allows = (operations: OperationAvailabilityDto[] | undefined, operation: string): boolean =>
  operations?.some((o) => o.operation === operation && o.allowed) ?? false;

export const departmentsForNewEvent = (org: { departments?: DepartmentDto[] }): DepartmentDto[] =>
  (org.departments ?? []).filter((d) => allows(d.operations, CREATE_SOURCING_EVENT));

export const departmentName = (org: { departments?: DepartmentDto[] }, departmentId: string | null | undefined) =>
  departmentId ? (org.departments ?? []).find((d) => d.id === departmentId)?.name : undefined;
